import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/named
import { RouteComponentProps } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { RestaurantMenuOptions as RedesignRestaurantMenuOptions } from '../../../pages';
import * as Actions from '../../actions/Actions';
import * as Api from '../../Api';
import * as B from '../../BasketControl';
import { Async } from '../../Data';
import { basketSelectors } from '../../redux';
import * as Routes from '../../Routes';
import { menuSelectors } from '../../selectors';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyConfigureItemHolder } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignRestaurantMenuOptions,
  LegacyConfigureItemHolder,
);

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type ItemRoute = RouteComponentProps<
  {
    vrid: number;
    type: 'collection' | 'delivery';
    concessionStoreId?: number;
    id: number;
    item: number;
    index: string;
  },
  {}
>;

const mapStateToProps = (state: Store.State, ownProps: ItemRoute) => {
  let item: Async<Api.MenuItem> = {
    status: 'pending',
  };

  let menuId = 0;

  const { flipdish, deliveryOptions } = state;
  const { MenuData, CollectionSummaries } = flipdish;
  const menu =
    ownProps.params.type === 'delivery'
      ? menuSelectors.findDeliveryMenu(
          {
            deliveryOptions,
            MenuData,
          },
          {
            vrId: ownProps.params.vrid,
            deliveryLocationId: ownProps.params.id,
          },
        )
      : menuSelectors.findCollectionMenu(
          {
            CollectionSummaries,
            MenuData,
          },
          {
            vrId: ownProps.params.vrid,
            prId: ownProps.params.id,
          },
        );

  if (menu) {
    let found = null;
    const itemId = parseInt(`${ownProps.params.item}`);
    for (
      let sectionIdx = 0;
      sectionIdx < menu.MenuSections.length;
      sectionIdx++
    ) {
      const section = menu.MenuSections[sectionIdx];

      for (let itemIdx = 0; itemIdx < section.MenuItems.length; itemIdx++) {
        const item = section.MenuItems[itemIdx];
        if (item.MenuItemId === itemId) {
          found = item;

          break;
        }
      }

      if (found) {
        break;
      }
    }

    if (found) {
      item = {
        status: 'success',
        data: found,
      };

      menuId = menu.MenuId;
    }
  }

  const basket = basketSelectors.getBasketBridge(state);

  return {
    AppDesignScheme: state.appDesignScheme,
    BasketItems: basket,
    CollectionSummaries: state.flipdish.CollectionSummaries,
    Customer: state.flipdish.Customer,
    DeliverySummaries: state.flipdish.DeliverySummaries,
    isDark: state.flipdish.isDark,
    Item: item,
    Languages: state.locale.languages,
    MenuId: menuId,
    Offset: state.flipdish.Offset,
    OptionsState: state.flipdish.OptionsState,
    Restaurant: Routes.FindRestaurant(state, ownProps),
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => {
  return {
    AddItemToBasket: (payload: B.Item) => {
      dispatch(Actions.AddToBasket(payload));
    },
    RemoveItemFromBasket: (payload: {
      menuId: number;
      index: number;
      indexName?: string;
    }) => {
      dispatch(Actions.RemoveFromBasket(payload));
    },

    SetLiveOptions: (options: Api.MenuItemOptionSetItem[]) => {
      dispatch(Actions.SetLiveOptions(options));
    },

    SetOptionsState: (
      options: Api.MenuItemOptionSetItem[],
      prevScreenOptions: Api.MenuItemOptionSetItem[][],
      current: number,
      prevIndices: number[],
    ) => {
      dispatch(
        Actions.SetOptionsState(
          options,
          prevScreenOptions,
          current,
          prevIndices,
        ),
      );
    },

    AddToast: (message: string) => {
      dispatch(Actions.AddToast(message));
    },

    PushLoginUrl: (url: string) => {
      dispatch(Actions.PushAfterLogin(url));
    },

    LoadRestaurant: (routes: Routes.Routes) => {
      dispatch(Actions.LoadRestaurant(routes));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
